const OrderByConfigForListProductScreen = [
  {
    label: 'Product Name',
    mode: 'desc',
    value: 'product_sku_desc',
  },
  {
    label: 'Product Name',
    mode: 'asc',
    value: 'product_sku_asc',
  },
  {
    label: 'Internal SKU Code',
    mode: 'desc',
    value: 'ref_product_code_desc',
  },
  {
    label: 'Internal SKU Code',
    mode: 'asc',
    value: 'ref_product_code_asc',
  },
  {
    label: 'Available Stock',
    mode: 'desc',
    value: 'quantity_desc',
  },
  {
    label: 'Available Stock',
    mode: 'asc',
    value: 'quantity_asc',
  },
  {
    label: 'Frequently Used',
    mode: 'desc',
    value: 'alter_id_desc',
  },
  {
    label: 'Frequently Used',
    mode: 'asc',
    value: 'alter_id_asc',
  },
];

const DefaultColumnsOnViewProduct = {
  INTERNAL_SKU_CODE: {
    label: 'SKU#',
    visible: true,
  },
  PRODUCT_NAME: {
    label: 'Product Name',
    visible: true,
  },
  PRODUCT_REF_CODE: {
    label: 'Internal SKU#',
    visible: true,
  },
  AVAILABLE_STOCK: {
    label: 'Available Stock (Primary)',
    visible: true,
  },
  SECONDARY_UOM: {
    label: 'Available Stock (Secondary)',
    visible: true,
  },
  STOCK_IN_STORE: {
    label: 'Stock on Store',
    visible: true,
  },
  REJECTED_STOCK_IN_STORE: {
    label: 'Bad Stock on Store',
    visible: false,
  },
  STORE_STOCK_STATUS: {
    label: 'Store Stock Status',
    visible: true,
  },
  BARCODE: {
    label: 'Barcode',
    visible: true,
  },
  HSN_CODE: {
    label: 'HSN Code',
    visible: false,
  },
  TAX: {
    label: 'Taxes',
    visible: false,
  },
  COST_PRICE: {
    label: 'Cost Price',
    visible: false,
  },
  SELLING_PRICE: {
    label: 'Selling Price',
    visible: false,
  },
  WEIGHTED_AVERAGE_COST_PRICE: {
    label: 'Weighted Average Price',
    visible: false,
  },
  WEIGHTED_AVERAGE_LANDING_PRICE: {
    label: 'Weighted Average Landing Price',
    visible: false,
  },
  UOM: {
    label: 'Unit of Measure',
    visible: false,
  },
  PURCHASE_UOM: {
    label: 'Purchase UOM',
    visible: false,
  },
  MRP: {
    label: 'MRP',
    visible: false,
  },
  THRESHOLD_QTY: {
    label: 'Minimum Threshold',
    visible: true,
  },
  IS_SALES_ENABLED: {
    label: 'Is Sales Enabled',
    visible: true,
  },
  IS_PURCHASE_ENABLED: {
    label: 'Is Purchase Enabled',
    visible: true,
  },
  QC_RULE: {
    label: 'QC Rule',
    visible: false,
  },
  PROJECTED_INCOMING_QTY: {
    label: 'Projected Incoming Qty',
    visible: false,
  },
  PROJECTED_OUTGOING_QTY: {
    label: 'Projected Outgoing Qty',
    visible: false,
  },
  PENDING_IN_QC_QTY: {
    label: 'Pending In Qc Qty',
    visible: false,
  },
};

const FixedColumnsOnViewProduct = ['INTERNAL_SKU_CODE'];

export {
  OrderByConfigForListProductScreen,
  DefaultColumnsOnViewProduct,
  FixedColumnsOnViewProduct,
};
